export default __webpack_public_path__ + "static/media/eye-slash-purple.216fd274.svg";